import { BasedB2CTransactionResponseModel } from "app/based/baseApiModel/baseTransactionHistory/basedB2CTransaction/BasedB2CTransactionResponseModel";
import { BasedDetailTransactionResponseModel } from "app/based/baseApiModel/baseTransactionHistory/basedDetailTransaction/BasedDetailTransactionResponseModel";

export class PackageRegistrationResponseEntity extends BasedB2CTransactionResponseModel {
  carrier?: string;
  partnerCode?: string;
  phoneNumber?: string;
  totalPrice?: string | number;
  package?: string;
  userName?: string;
  partnerName?: string;
  userPhone?: string;
  buyerPhone?: string;
  userEmail?: string;
  currency?: string;
  beforeCredit?: string;
  afterCredit?: string;
  supplierRefCode?: string;

  constructor(data?: Partial<PackageRegistrationResponseEntity>) {
    super(data);
    Object.assign(this, data);
  }
}

export class PackageRegistrationDetailEntity extends BasedDetailTransactionResponseModel {}
